import React from "react";

const JsonToTablePreview = ({ config, classes }) => {
  const { columns = [], show_border = false, show_header = true, table_style = "default" } = config;

  const tableStyles = {
    default: {
      border: show_border ? "1px solid black" : "none",
      width: "100%",
      borderCollapse: "collapse"
    },
    alt_row: {
      border: show_border ? "1px solid black" : "none",
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff"
    },
    alt_col: {
      border: show_border ? "1px solid black" : "none",
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#ffffff"
    }
  };

  const getRowStyle = (index) => {
    if (table_style === "alt_row") {
      return { backgroundColor: index % 2 === 0 ? "#f2f2f2" : "#ffffff" };
    }
    return {};
  };

  const getCellStyle = (colIndex) => {
    if (table_style === "alt_col") {
      return { backgroundColor: colIndex % 2 === 0 ? "#f2f2f2" : "#ffffff" };
    }
    return {};
  };

  return (
    <div
      className="table-container z-tableView"
      style={{ position: "relative", display: "inline-block", width: "100%" }}
    >
      <table className={`${classes}`} style={tableStyles[table_style] || tableStyles.default}>
        {show_header && (
          <thead className="z-table-header">
            <tr>
              {columns.map((col) => (
                <th
                  key={col.id}
                  style={{
                    border: show_border ? "1px solid var(--z-rv-table-border)" : "none",
                    position: "relative",
                    padding: "6px 8px",
                    textAlign: "left"
                  }}
                  className={col.classes?.join(" ") || ""}
                >
                  <span>{col.header_name}</span>
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {[...Array(3)].map((_, rowIndex) => (
            <tr key={`row-${rowIndex}`} style={getRowStyle(rowIndex)}>
              {columns.map((col, colIndex) => (
                <td
                  key={`${rowIndex}-${col.id}`}
                  style={{
                    border: show_border ? "1px solid var(--z-rv-table-border)" : "none",
                    ...getCellStyle(colIndex),
                    position: "relative",
                    padding: "6px 8px",
                    color: "#666"
                  }}
                  className={col.classes?.join(" ") || ""}
                >
                  {col.placeholder || ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JsonToTablePreview;
